import { render, staticRenderFns } from "./VendorProfileForm.vue?vue&type=template&id=20b1b8a2&scoped=true"
import script from "./VendorProfileForm.vue?vue&type=script&lang=js"
export * from "./VendorProfileForm.vue?vue&type=script&lang=js"
import style0 from "./VendorProfileForm.vue?vue&type=style&index=0&id=20b1b8a2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b1b8a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b1b8a2')) {
      api.createRecord('20b1b8a2', component.options)
    } else {
      api.reload('20b1b8a2', component.options)
    }
    module.hot.accept("./VendorProfileForm.vue?vue&type=template&id=20b1b8a2&scoped=true", function () {
      api.rerender('20b1b8a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/erp/VendorProfileForm.vue"
export default component.exports